import React, { useEffect, useState } from "react";
import ReactSelect, {components} from "react-select";
import {EventBus, EventBusEvents} from "@/store/event-bus";
import {chatbotListQuery} from "@/store/chatbot";
import {useParams, useSearchParams} from "react-router-dom";

const OptionComponent = ({ data, ...props}) => {
  return (
    /*@ts-ignore*/
    <components.Option {...props}>
      <div className="flex items-center">
        <span className="ml-2">{data.label}</span>
      </div>
    </components.Option>
  );
};
const BotSelector = () => {
  const { chatbotID } = useParams()
  const listQuery = chatbotListQuery()

  if (!listQuery.data) {
    return (<div></div>)
  }

  let botListOptions : any[] = [];
  for (let i=0; i<listQuery.data.length; i++) {
    let name = listQuery.data[i]?.settings?.name
    botListOptions.push({
      value: listQuery.data[i].id,
      label: name ? name : `Chatbot #${listQuery.data.length-i}`
    })
  }

  const currentOption = botListOptions.findIndex((item) => {
    return chatbotID === item.value
  })

  return (
    <ReactSelect
      options={[{
        options: botListOptions,
      }]}
      placeholder="Chatbots"
      className="react-select"
      classNamePrefix="select"
      components={{
        Option: OptionComponent,
      }}
      value={currentOption !== -1 ? botListOptions[currentOption] : null}
      onChange={(e : any) => {
        EventBus.getInstance().dispatch(EventBusEvents.chatbotChanged, {id : e.value})
      }}
    />
  )

}

export default BotSelector;